const getMoonEmoji = (phase) => {
  const phaseLower = phase?.toLowerCase() || "";
  if (phaseLower.includes("new")) return "🌑";
  if (phaseLower.includes("waxing crescent")) return "🌒";
  if (phaseLower.includes("first quarter")) return "🌓";
  if (phaseLower.includes("waxing gibbous")) return "🌔";
  if (phaseLower.includes("full")) return "🌕";
  if (phaseLower.includes("waning gibbous")) return "🌖";
  if (phaseLower.includes("last quarter")) return "🌗";
  if (phaseLower.includes("waning crescent")) return "🌘";
  return "🌙";
};

const getMoonDescription = (phase) => {
  const phaseLower = phase?.toLowerCase() || "";
  if (phaseLower.includes("new")) return "The Moon is between Earth and the Sun, not visible from Earth.";
  if (phaseLower.includes("waxing crescent")) return "A small sliver of the Moon is visible and growing.";
  if (phaseLower.includes("first quarter")) return "Half of the Moon is illuminated and waxing.";
  if (phaseLower.includes("waxing gibbous")) return "More than half illuminated, approaching Full Moon.";
  if (phaseLower.includes("full")) return "The entire face of the Moon is illuminated. Perfect for night viewing!";
  if (phaseLower.includes("waning gibbous")) return "More than half illuminated, decreasing after Full Moon.";
  if (phaseLower.includes("last quarter")) return "Half of the Moon is illuminated and waning.";
  if (phaseLower.includes("waning crescent")) return "A small sliver of the Moon is visible and shrinking.";
  return "Current lunar phase information.";
};

export const MoonPhaseCard = ({ moon }) => (
  <div className="glass-card p-8 text-center">
    <div className="mb-8">
      <span className="text-[120px] md:text-[160px] leading-none">
        {getMoonEmoji(moon.phase)}
      </span>
    </div>

    <div className="mb-6">
      <h2 className="font-heading font-bold text-3xl md:text-4xl text-white mb-2">
        {moon.phase}
      </h2>
      <p className="text-slate-400 max-w-md mx-auto">
        {getMoonDescription(moon.phase)}
      </p>
    </div>

    <div className="inline-block bg-white/5 rounded-2xl px-8 py-4 mb-6">
      <p className="text-xs text-slate-500 uppercase tracking-widest font-heading mb-1">
        Illumination
      </p>
      <p className="text-5xl font-mono font-bold text-white">
        {moon.illumination}%
      </p>
    </div>

    <p className="text-sm text-slate-500">
      Day {moon.phase_day} of 29.5 day lunar cycle
    </p>
  </div>
);
